import React from 'react';
import LineSeparator from '../../Basic/LineSeparator/LineSeparator.mjs';
import BottomLinks from '../../UIElements/BottomLinks/BottomLinks.mjs';
import MenuContent from '../../UIElements/MenuContent/MenuContent.mjs';
import Newsletter from '../../UIElements/Newsletter/Newsletter.mjs';
import RegionSelector from '../../UIElements/RegionSelector/RegionSelector.mjs';
import Search from '../../UIElements/Search/Search.mjs';
import { StyledNavigationSidebarWrapper, StyledContainer } from './MobileNavigation.styles.mjs';

const MobileNavigation = ({ menu, secondaryMenu, newsletter, regionSelectorProps, searchProps }) => {
    return (React.createElement(StyledNavigationSidebarWrapper, null,
        React.createElement(StyledContainer, null,
            React.createElement(Search, Object.assign({}, searchProps))),
        React.createElement(MenuContent, { sections: menu }),
        React.createElement(LineSeparator, null),
        React.createElement(RegionSelector, Object.assign({}, regionSelectorProps)),
        React.createElement(Newsletter, Object.assign({}, newsletter)),
        React.createElement(BottomLinks, { options: secondaryMenu })));
};

export { MobileNavigation as default };
//# sourceMappingURL=MobileNavigation.mjs.map
